import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html',
  styleUrls: ['./expenses.component.css']
})
export class ExpensesComponent implements OnInit {

  public menu_item_id = '94';
  cost_centers = [];
  custody_list = [];
  expenseList = [];
  expenseDetail = '';
  custodyList = [];
  custodyDetail = '';

  model = {
    'table_name': 'expenses', 'exp_id': '0', 'exp_no': '', 'invoice_no': '', 'invoice_date': '', 'amount': '',
    'flag': 'new', 'key': 'exp_id', 'exp_acct': '', 'exp_desc': '', 'paid_from': 'casher', 'acct_number': '',
    'cost_center': '0', 'comment': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  date_model = { 'invoice_date': new Date() };

  // search_obj = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //       'condition': " AND `sub_acct`.`is_leaf` = '1' AND `sub_acct`.`is_cc` = '1'"
  //     }
  //   ]
  // };

  // search_acct = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //       'condition': " AND `sub_acct`.`is_leaf` = '1' AND `sub_acct`.`is_cc` = '1'"
  //     }
  //   ]
  // };

  // search_obj = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //     'condition': " AND `sub_acct`.`acct_type_no` = '8'"
  //   }]
  // };

  // search_acct = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //     'condition': " AND `sub_acct`.`main_acct_no` = '104'"
  //   }]
  // };

  Acct_Placeholder; Invoice_No_Msg; Ex_Acct_Msg; CC_Msg;
  Amount_Msg; Pay_Msg; Success_Msg; Error_Msg; Expenses_No;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<ExpensesComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    // this.search_obj['placeholder'] = this.Acct_Placeholder;
    // this.search_acct['placeholder'] = this.Acct_Placeholder;

    translate.get('Invoice_No_Msg').subscribe((res: string) => {
      this.Invoice_No_Msg = res;
    });

    translate.get('Ex_Acct_Msg').subscribe((res: string) => {
      this.Ex_Acct_Msg = res;
    });

    translate.get('CC_Msg').subscribe((res: string) => {
      this.CC_Msg = res;
    });

    translate.get('Amount_Msg').subscribe((res: string) => {
      this.Amount_Msg = res;
    });

    translate.get('Pay_Msg').subscribe((res: string) => {
      this.Pay_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    }); 

    translate.get('Expenses_No').subscribe((res: string) => {
      this.Success_Msg = res;
    });
  }

  ngOnInit() {

    let query, obj;
    // get leaf expenses accts
    let parent_acct = this.applicationConstants.main_acct_config['expenses_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.expenseList = data.data['list'];
      });

    // get leaf custody accts
    parent_acct = this.applicationConstants.main_acct_config['custody'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.custodyList = data.data['list'];
      });

    query = "SELECT * FROM `cost_center` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_centers = data.data['list'];

        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.cost_centers.unshift(costObj);
      });

    let query1 = "SELECT * FROM `sub_acct` WHERE `main_acct_no` = '104' AND `status` = '1'";
    let obj1 = { cmd: 'getList', query: query1 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.custody_list = data.data['list'];
      });

    ///////////////////////// EDIT /////////////////////////

    if (this.dialog_data != null) {
      this.model = this.dialog_data;
      if (this.model['exp_acct'] != '0') {
        query = this.queryList.all_subAcct + " AND `acct_number` = '" + this.model['exp_acct'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            // (document.getElementById("search_value_0") as HTMLInputElement).value 
            this.expenseDetail = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
          });
      }
      if (this.model['paid_from'] == 'custody') {
        if (this.model['acct_number'] != '') {
          query = this.queryList.all_subAcct + " AND `acct_number` = '" + this.model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              // (document.getElementById("search_value_1") as HTMLInputElement).value 
              this.custodyDetail = data.data['list'][0]['acct_number'] +
                "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];

              if (this.model['invoice_no'] == '' && this.model['acct_number'] != '')
                (document.getElementById("search_value_1") as HTMLInputElement).disabled = true;
            });
        }
        if (this.model['invoice_no'] == '' && this.model['acct_number'] != '')
          (document.getElementById("paid_from") as HTMLInputElement).disabled = true;

      }
      this.date_model['invoice_date'] = new Date(this.dialog_data.invoice_date);
    }

  }

  onChangeExpense = function (acct_number: string) {
    this.model['exp_acct'] = acct_number;
  }

  onChangeCustody = function (acct_number: string) {
    this.model['acct_number'] = acct_number;
  }

  add() {
    if (this.model['invoice_no'] == '') {
      alert(this.Invoice_No_Msg);
      (document.getElementById("invoice_no") as HTMLInputElement).focus();
    }
    else if (this.model['exp_acct'] == '') {
      alert(this.Ex_Acct_Msg);
      (document.getElementById("search_value_0") as HTMLInputElement).focus();
    }
    else if (this.model['cost_center'] == '') {
      alert(this.CC_Msg);
      (document.getElementById("cost_center") as HTMLInputElement).focus();
    }
    else if (Number(this.model['amount']) == 0 || isNaN(Number(this.model['amount']))) {
      alert(this.Amount_Msg);
      this.model['amount'] = '';
      (document.getElementById("amount") as HTMLInputElement).focus();
    }
    else if (this.model['paid_from'] == '') {
      alert(this.Pay_Msg);
      (document.getElementById("paid_from") as HTMLInputElement).focus();
    }
    else {
      let values = [];
      this.model['invoice_date'] = (this.date_model['invoice_date'].getFullYear() + "-" +
        (this.date_model['invoice_date'].getMonth() + 1) + "-" + this.date_model['invoice_date'].getDate() + ' ' +
        (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds());

      if (this.model['paid_from'] == 'casher')
        this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;

      values.push(this.model);
      let obj;

      if (this.model['exp_id'] == '0' || this.model['flag'] == 'new') {
        let year = this.date_model['invoice_date'].getFullYear();
        let prefix = this.model['branch_id'] + "-" + year + "-";

        obj = { cmd: 'add', values: values, pk: 'exp_no', id: 'exp_id', main_table: 'expenses', 
          prefix: prefix };
      }
      else 
        obj = { cmd: 'updateAdv', values: values };
      
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
           
            if (this.model['exp_no'] == '')
              this.model['exp_no'] = data.status['msg'][0]['number'];

            alert(this.Success_Msg + ", " + this.Expenses_No + ": " + this.model['exp_no']);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
